import { FC, useContext } from 'react';
import clsx from 'clsx';
import { AccuWeatherHeaderProps } from '../AccuWeather.types';
import { PageParamsContext } from '../../../modules/context/PageContext';
import {
  weatherIcons,
  analyticsTrackingIdentifier,
  analyticsTrackingUniqueDescription,
} from '../../../modules/utils/constants/constants';
// import { useAccuWeatherData } from '../context/AccuWeatherDataContext';
import { AccuWeatherMockUXL } from '../__mock__/AccuWeatherMock';
import { accuWeatherStore, useAccuWeatherStore } from '../../../modules/store/accuWeatherStore';

export const AccuWeatherHeader: FC<AccuWeatherHeaderProps> = ({
  accuWeatherImage,
  imageAltText,
  isAuthorMode,
  showAccuWeatherInL1 = false,
}) => {
  const { preProcessorResponse } = useContext(PageParamsContext);
  const { cna = false, sameTab = false } = preProcessorResponse || {};
  const accuWeatherData = useAccuWeatherStore((state: accuWeatherStore) => state.accuWeatherData);
  const data = isAuthorMode ? { ...AccuWeatherMockUXL } : accuWeatherData ? { ...accuWeatherData } : null;

  return data?.property?.weather?.hourly.length > 0 ? (
    <div
      className={clsx(
        'accu-weather__container d-flex justify-content-end',
        `${showAccuWeatherInL1 ? 'accu-weather__container-local-header' : ''}`
      )}
    >
      <a
        href={`${data?.property?.weather?.hourly[0]?.link}&partner=web_marriott_adc`}
        target={sameTab || cna ? '_self' : '_blank'}
        className="accu-weather__container__wrapper custom_click_track"
        data-custom_click_track_value={`${analyticsTrackingIdentifier?.accuweather}|${analyticsTrackingUniqueDescription.accuWeatherWeatherForecast}|external|`}
        rel="noreferrer"
      >
        <div className="d-flex accu-weather__container__wrapper-cell">
          <div className="icon-cell">
            {weatherIcons?.map(
              icon =>
                data?.property?.weather?.hourly[0]?.weatherIcon === icon.iconKey && (
                  <span className={icon.iconClass}></span>
                )
            )}
          </div>
          <div>
            <span className="temperature-cell t-font-m">
              {Math.trunc(data?.property?.weather?.hourly[0]?.temperature?.value)}
            </span>
            <span className="unit-cell">°{data?.property?.weather?.hourly[0]?.temperature?.unit}</span>
          </div>
        </div>
      </a>
      <div className="accu-weather__container__logo pl-2 pl-xl-3 d-flex">
        <a
          href={`${data?.property?.weather?.hourly[0]?.link}&partner=web_marriott_adc`}
          target={sameTab || cna ? '_self' : '_blank'}
          rel="noreferrer"
          className="d-flex align-items-center custom_click_track"
          data-custom_click_track_value={`${analyticsTrackingIdentifier?.accuweather}|${analyticsTrackingUniqueDescription.accuWeatherWeatherForecast}|external|`}
          data-testid="accu-weather-header-link"
        >
          <span>
            <img
              src={accuWeatherImage}
              alt={imageAltText}
              data-testid="accu-weather-logo"
              className="accu-weather__container__logo_img d-none d-xl-flex"
            ></img>
          </span>
          <span className="d-flex d-xl-none icon-forward-arrow t-accent-color"></span>
        </a>
      </div>
    </div>
  ) : null;
};
